import { render, staticRenderFns } from "./AccionAsociarDocumento.vue?vue&type=template&id=528454c0&scoped=true&"
import script from "./AccionAsociarDocumento.vue?vue&type=script&lang=js&"
export * from "./AccionAsociarDocumento.vue?vue&type=script&lang=js&"
import style0 from "./AccionAsociarDocumento.vue?vue&type=style&index=0&id=528454c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "528454c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('528454c0')) {
      api.createRecord('528454c0', component.options)
    } else {
      api.reload('528454c0', component.options)
    }
    module.hot.accept("./AccionAsociarDocumento.vue?vue&type=template&id=528454c0&scoped=true&", function () {
      api.rerender('528454c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/dte/componentes/acciones/AccionAsociarDocumento.vue"
export default component.exports